import {Path, useFormContext} from 'react-hook-form';

export const useSetFieldValueCb = <T>(): ((name: Path<T>, value: any) => void) => {
   const methods = useFormContext<T>();

   return methods.setValue;
};
